import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-arquivo-sia',
    templateUrl: './arquivo-sia.component.html',
    styleUrls: ['./arquivo-sia.component.css']
})
export class ArquivoSiaComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/arquivo-sia/arquivo-sia.component.ts